<template>
  <v-card>
    <v-card-title>
      港：
      <lookup :value="departurePortCode" url="ports/kv" />&nbsp;&nbsp;作業：
      <lookup :value="departureWorkId" url="charge-item-sub-type/kv" />⇒
      経由先：
      <lookup
        :value="transitWarehouseId"
        url="warehouses/kv"
      />&nbsp;&nbsp;作業：
      <lookup :value="transitWorkId" url="charge-item-sub-type/kv" />⇒ 納入先：
      <lookup
        :value="destinationWarehouseId"
        url="warehouses/kv"
      />&nbsp;&nbsp;作業：
      <lookup :value="destinationWorkId" url="charge-item-sub-type/kv" />
      <v-spacer />
      <div class="mr-2">配送パターン:</div>
      <lookup
        :value="detail.deliveryPatternCode"
        item-text="name"
        item-value="code"
        url="patterns/all"
      />
      <v-btn
        :disabled="this.detail.drakeSharing || isWarehouseTransport"
        @click="patternSearch"
        icon
      >
        <v-icon>search</v-icon>
      </v-btn>
    </v-card-title>
    <v-container fluid>
      <v-layout :key="index" row v-for="(route, index) in detail.routes" wrap>
        <v-flex md3 sm6 xs12>
          <div required>
            <remote-autocomplete
              disabled
              :label="route.label || '配送業者'"
              :rules="[
                (v) => !!v || `${route.label || '配送業者'} is required`,
              ]"
              :url="transportUrl"
              v-model="route.deliverySupplierId"
            />
          </div>
        </v-flex>
        <v-flex md3 sm6 xs12>
          <div required>
            <remote-select
              disabled
              :filter="(i) => i.isDelivery && filterDeliveryModeId(i)"
              :rules="[(v) => !!v || `搬送サービス is required`]"
              @change="changeTransportType"
              item-text="ja_JP"
              item-value="id"
              label="搬送サービス"
              url="charge-item-sub-type"
              v-model="route.deliveryModelId"
            />
          </div>
        </v-flex>
        <v-flex
          md2
          sm6
          v-if="route.deliveryModelId != 'CHARGE_ITEM_SUB_TYPE-MIX_LOADING'"
          xs12
        >
          <remote-select
            :disabled="
              !canEdit ||
              detail.routes[index].deliveryModelId ==
                'CHARGE_ITEM_SUB_TYPE-DRAKE'
            "
            item-text="ja_JP"
            item-value="id"
            label="トラックトン数"
            url="truck-types"
            v-model="route.truckTypeId"
          />
        </v-flex>
        <v-flex
          md2
          sm6
          v-if="route.deliveryModelId != 'CHARGE_ITEM_SUB_TYPE-MIX_LOADING'"
          xs12
        >
          <v-text-field
            :disabled="
              !canEdit ||
              detail.routes[index].deliveryModelId ==
                'CHARGE_ITEM_SUB_TYPE-DRAKE'
            "
            :rules="[
              (v) =>
                !v || /^[0-9][0-9]{0,1}$/.test(v) || `トラック台数 最大值99`,
            ]"
            clearable
            label="トラック台数"
            type="number"
            v-model="route.truckAmount"
          ></v-text-field>
        </v-flex>
        <v-flex
          md2
          sm6
          v-if="
            isCharter(detail.routes[index]) || isDrake(detail.routes[index])
          "
          xs12
        >
          <remote-select
            disabled
            :rules="[(v) => v != null || `必須項目`]"
            label="Special"
            url="delivery-specials/kv"
            v-model="route.deliverySpecialId"
          />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md6 sm6 xs12>
          <remote-autocomplete
            :disabled="true"
            item-text="text"
            item-value="value"
            label="通关業者"
            :url="customsUrl"
            v-model="detail.customsDirectorId"
          ></remote-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md6 sm6 xs12>
          <remote-autocomplete
            disabled
            @change="changeJobSupplierId"
            item-text="text"
            item-value="value"
            label="デバン業者"
            :url="devanUrl"
            v-if="detail.stackTypeId"
            v-model="jobSupplierId"
          ></remote-autocomplete>
        </v-flex>
      </v-layout>
    </v-container>
    <pattern-dialog :detail="detail" ref="patternDialog" />
  </v-card>
</template>
<script>
import PatternDialog from "./PatternDialog";

export default {
  props: ["detail"],
  components: {
    PatternDialog,
  },
  data() {
    return {
      selectedPattern: null,
      jobSupplierId: null,
      query: {},
    };
  },
  watch: {
    "detail.routes"() {
      this.detail.routes.forEach((r) => {
        if (r.deliveryModelId == "CHARGE_ITEM_SUB_TYPE-DRAKE") {
          r.truckAmount = 1;
        }
      });
    },
    detail() {
      this.setJobSupplierId();
      // if (this.isFCL) {
      //   console.log("isFcl");
      //   this.detail.routes.forEach(r => (r.truckAmount = 1));
      // }
    },
  },
  computed: {
    customsUrl() {
      return this.detail.status === "DO確定済"
        ? "companies/kv-include-all"
        : "companies/customs/kv";
    },
    devanUrl() {
      return this.detail.status === "DO確定済"
        ? "companies/kv-include-all"
        : "companies/devan/kv";
    },
    transportUrl() {
      return this.detail.status === "DO確定済"
        ? "companies/kv-include-all"
        : "companies/transport/kv";
    },
    hasDevan() {
      return (
        this.detail.routes.filter((r) => {
          return (
            r.departureJobId === "CHARGE_ITEM_SUB_TYPE-DEVAN" ||
            r.destinationJobId === "CHARGE_ITEM_SUB_TYPE-DEVAN"
          );
        }).length > 0
      );
    },
    deliverySpecial1Id() {
      return (
        this.detail.routes &&
        this.detail.routes.length > 0 &&
        this.detail.routes[0].deliverySpecialId
      );
    },
    deliverySpecial2Id() {
      return (
        this.detail.routes &&
        this.detail.routes.length > 1 &&
        this.detail.routes[1].deliverySpecialId
      );
    },

    isWarehouseTransport() {
      return (
        ((this.detail.transportModeId &&
          this.detail.transportModeId.indexOf("-AIR") !== -1) ||
          (this.detail.stackTypeId &&
            this.detail.stackTypeId.indexOf("-FCL") !== -1)) &&
        this.detail.isAllUnpaid &&
        this.detail.specialId &&
        this.detail.specialId.indexOf("WAREHOUSE_TRANSPORT") !== -1
      );
    },
    isFCL() {
      return (
        this.detail.stackTypeId && this.detail.stackTypeId == "STACK_TYPE-FCL"
      );
    },
    canEdit() {
      if (this.detail.drakeSharing) {
        return false;
      }
      return this.detail.routes &&
        this.detail.routes.length > 0 &&
        this.detail.routes.filter(
          (r) =>
            (r.departurePortCode == null && r.departureWarehouseId == null) ||
            r.destinationWarehouseId == null
        ).length > 0
        ? false
        : true;
    },
    departurePortCode() {
      return (
        this.detail.routes &&
        this.detail.routes.length > 0 &&
        this.detail.routes.filter((i) => i.seq == 1)[0].departurePortCode
      );
    },
    departureWorkId() {
      return (
        this.detail.routes &&
        this.detail.routes.length > 0 &&
        this.detail.routes.filter((i) => i.seq == 1)[0].departureJobId
      );
    },
    transitWarehouseId() {
      if (this.detail.routes) {
        if (this.detail.routes.length == 2) {
          return this.detail.routes.filter((i) => i.seq == 1)[0]
            .destinationWarehouseId;
        }
      }
      return null;
    },
    transitWorkId() {
      if (this.detail.routes) {
        if (this.detail.routes.length == 2) {
          return this.detail.routes.filter((i) => i.seq == 1)[0]
            .destinationJobId;
        }
      }
      return null;
    },
    destinationWarehouseId() {
      if (this.detail.routes) {
        if (this.detail.routes.length == 2) {
          return this.detail.routes.filter((i) => i.seq == 2)[0]
            .destinationWarehouseId;
        } else if (this.detail.routes.length == 1) {
          return this.detail.routes.filter((i) => i.seq == 1)[0]
            .destinationWarehouseId;
        }
      }
      return null;
    },
    destinationWorkId() {
      if (this.detail.routes) {
        if (this.detail.routes.length == 2) {
          return this.detail.routes.filter((i) => i.seq == 2)[0]
            .destinationJobId;
        } else if (this.detail.routes.length == 1) {
          return this.detail.routes.filter((i) => i.seq == 1)[0]
            .destinationJobId;
        }
      }
      return null;
    },
  },

  methods: {
    isCharter(route) {
      return route.deliveryModelId == "CHARGE_ITEM_SUB_TYPE-CHARTER";
    },
    isDrake(route) {
      return route.deliveryModelId == "CHARGE_ITEM_SUB_TYPE-DRAKE";
    },
    filterDeliveryModeId(item) {
      if (this.detail.stackTypeId === "STACK_TYPE-FCL") return true;
      return !item.isDrake;
    },
    changeTransportType() {
      this.detail.routes.forEach((r) => {
        if (r.deliveryModelId == "CHARGE_ITEM_SUB_TYPE-DRAKE") {
          this.$nextTick(() => {
            r.truckAmount = 1;
            r.truckTypeId = null;
            this.$forceUpdate();
          });
        }
      });
    },
    patternSearch() {
      this.$refs.patternDialog
        .popup(this.detail.deliveryPatternCode)
        .then((pattern) => {
          this.setPattern(pattern);
          this.$refs.patternDialog.refreshPattern();
        });
    },
    setJobSupplierId() {
      // this.jobSupplierId = null
      if (this.detail.routes != null) {
        let arr = this.detail.routes.filter(
          (i) =>
            i.departureJobSupplierId != null ||
            i.destinationJobSupplierId != null
        );
        if (arr.length > 0) {
          this.jobSupplierId =
            arr[0].departureJobSupplierId || arr[0].destinationJobSupplierId;
        }
      }
    },
    changeJobSupplierId(val) {
      // if (val == null) {
      //   this.detail.routes.forEach(i => {
      //     i.departureJobId = null;
      //     i.departureSupplierId = null;
      //     i.destinationJobId = null;
      //     i.destinationJobSupplierId = null;
      //   });
      //   return;
      // }
      let wantChangedRoute = this.detail.routes.find(
        (i) => i.departureJobId != null || i.destinationJobId != null
      );
      if (wantChangedRoute && wantChangedRoute.departureJobId !== null) {
        wantChangedRoute.departureJobSupplierId = val;
      } else if (
        wantChangedRoute &&
        wantChangedRoute.destinationJobId !== null
      ) {
        wantChangedRoute.destinationJobSupplierId = val;
      }
    },
    setPattern(pattern) {
      this.detail.routes = [];
      this.detail.deliveryPatternCode =
        pattern.code && pattern.code !== "" ? pattern.code : null;
      this.selectedPattern = pattern;
      if (pattern.transitWarehouseId != null) {
        this.detail.routes = [
          {
            label: "A配送業者",
            departurePortCode: pattern.departurePortCode,
            departureWarehouseId: pattern.departureWarehouseId,
            departureType:
              pattern.departureWarehouseId == null ? "PORT" : "WAREHOUSE",
            destinationWarehouseId: pattern.transitWarehouseId,
            destinationType: "WAREHOUSE",
            deliveryModelId: pattern.deliveryModel1Id,
            deliverySupplierId: pattern.delivery1Id,
            departureJobId: pattern.departureWorkId,
            departureJobSupplierId: pattern.departureSupplierId,
            destinationJobId: pattern.transitWorkId,
            destinationJobSupplierId: pattern.transitSupplierId,
            deliverySpecialId: pattern.deliverySpecial1Id,
            seq: 1,
          },
          {
            label: "B配送業者",
            departureWarehouseId: pattern.transitWarehouseId,
            departureType: "WAREHOUSE",
            destinationWarehouseId: pattern.destinationWarehouseId,
            destinationType: "WAREHOUSE",
            deliveryModelId: pattern.deliveryModel2Id,
            deliverySupplierId: pattern.delivery2Id,
            destinationJobId: pattern.destinationWorkId,
            destinationJobSupplierId: pattern.destinationSupplierId,
            deliverySpecialId: pattern.deliverySpecial2Id,
            seq: 2,
          },
        ];
      } else {
        this.detail.routes = [
          {
            label: "A配送業者",
            departurePortCode: pattern.departurePortCode,
            departureWarehouseId: pattern.departureWarehouseId,
            departureType:
              pattern.departureWarehouseId == null ? "PORT" : "WAREHOUSE",
            destinationWarehouseId: pattern.destinationWarehouseId,
            destinationType: "WAREHOUSE",
            deliveryModelId: pattern.deliveryModel1Id,
            deliverySupplierId: pattern.delivery1Id,
            departureJobId: pattern.departureWorkId,
            departureJobSupplierId: pattern.departureSupplierId,
            destinationJobId: pattern.destinationWorkId,
            destinationJobSupplierId: pattern.destinationSupplierId,
            deliverySpecialId: pattern.deliverySpecial1Id,
            seq: 1,
          },
        ];
      }
      this.setJobSupplierId();
    },
  },
};
</script>
